"use client";
export default function DisclaimerNotice({ onDismiss }) {
  return (
    <div className="text-sm text-yellow-300 bg-surface border border-yellow-600 p-3 rounded-md mt-3 text-center leading-relaxed relative">
      <strong className="text-yellow-400">⚠️ Reminder:</strong><br />
      Please enter the phone number carefully. ReloadPi has implemented checks to avoid mistakes.<br />
      However, in case of incorrect input (e.g., 123 instead of 124), <strong>ReloadPi is not responsible</strong> for failed delivery or losses.
      
      <button
        onClick={onDismiss}
        className="absolute top-1 right-2 text-xs text-yellow-400 hover:underline"
      >
        Dismiss
      </button>
    </div>
  );
}
    